module.exports = __webpack_public_path__ + "static/1-008-ead3477734c840d09727491e9ac843f4.png";